let dateRegex = /^([0-9]{4}(\-[0-9]{2}){2})/;
let dbDateRegex = /([0-9]{4})-([0-1]{1}[0-9]{1})-([0-3]{1}[0-9]{1}) ([0-2]{1}[0-9]{1}):([0-6]{1}[0-9]{1}):([0-6]{1}[0-9]{1})/;
export const locales = {
	en: {
		monthNames: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
		monthNamesShort: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
	},
};

export function formatNumber(number) {
	if (parseInt(number, 10) < 10) {
		return '0' + number;
	}

	return number.toString();
}

export function millisToMinutesAndSeconds(millis) {
	const minutes = Math.floor(millis / 60000);
	const seconds = ((millis % 60000) / 1000).toFixed(0);
	return minutes + ':' + (seconds < 10 ? '0' : '') + seconds;
  }

export class DateFormatter {

	constructor(dateStr = '') {
		if ((typeof dateStr === 'string') && dateStr.length) {
			//YYYY-MM-DD HH:MM:SS

			if (dbDateRegex.test(dateStr)) {
				let match = dbDateRegex.exec(dateStr);
				this._internalDate = new Date(match[1], (parseInt(match[2], 10) - 1), match[3], match[4], match[5], match[6]);
			} else if (dateRegex.test(dateStr)) {
				//Removing substr as we need the time in some locations.
				dateStr = dateStr.substr(0, 10);
				this._internalDate = new Date(dateStr);
			} else {
				console.warn('DateFormatter expect a string in the format "YYYY-MM-DD", was: ' + dateStr.toString());
				this._internalDate = new Date();
			}
		} else if ((typeof dateStr === 'number') && dateStr) {
			this._internalDate = new Date(dateStr);
		} else {
			this._internalDate = new Date();
		}
	}

	addTime(ms) {
		if (typeof ms === 'number') {
			this._internalDate = new Date(this._internalDate.getTime() + ms);
		}
	}

	get date() {
		return formatNumber(this._internalDate.getUTCDate());
	}

	get month() {
		return locales.en.monthNames[this._internalDate.getUTCMonth()];
	}

	get monthShort() {
		return locales.en.monthNamesShort[this._internalDate.getUTCMonth()];
	}

	get year() {
		return this._internalDate.getUTCFullYear();
	}

	get dayOfWeek() {
		return this._internalDate.getUTCDay();
	}

	get week() {
		// Copy date so don't modify original
		let d = new Date(this._internalDate);
		d.setHours(0, 0, 0);

		// Set to nearest Thursday: current date + 4 - current day number
		// Make Sunday's day number 7
		d.setDate(d.getUTCDate() + 4 - (d.getUTCDay() || 7));

		// Get first day of year
		let yearStart = new Date(d.getUTCFullYear(), 0, 1);

		// Calculate full weeks to nearest Thursday
		let weekNo = Math.ceil((((d - yearStart) / 86400000) + 1) / 7);

		return weekNo;
	}

	get monthAndYear() {
		let month = locales.en.monthNames[this._internalDate.getUTCMonth()];

		return `${this.month}, ${this._internalDate.getUTCFullYear()}`;
	}

	get monthDateAndYear() {
		let month = locales.en.monthNames[this._internalDate.getUTCMonth()];

		return `${this.month} ${this._internalDate.getUTCDate()}, ${this._internalDate.getUTCFullYear()}`;
	}

	get dateMonthAndYear() {
		let month = locales.en.monthNames[this._internalDate.getUTCMonth()];

		return `${this._internalDate.getUTCDate()} ${this.month}, ${this._internalDate.getUTCFullYear()}`;
	}

	get dateShortMonthAndYear() {
		let month = locales.en.monthNames[this._internalDate.getUTCMonth()];

		return `${this._internalDate.getUTCDate()} ${this.monthShort}, ${this._internalDate.getUTCFullYear()}`;
	}

	get prettyTime() {
		let hours = this._internalDate.getUTCHours();
		let minutes = '0' + this._internalDate.getUTCMinutes();
		let seconds = '0' + this._internalDate.getUTCSeconds();

		// Will display time in 10:30:23 format
		return hours + ':' + minutes.substr(-2) + ':' + seconds.substr(-2);
	}

	getTime() {
		return this._internalDate.getTime();
	}

	calculateDaysBetweenString(endDate = '') {
		let eDate = (typeof endDate === 'object') ? endDate : new DateFormatter(endDate);

		if (typeof eDate.getTime !== 'function') {
			return '??';
		}

		let createStamp = this._internalDate.getTime();
		let winStamp = eDate.getTime();

		let days = Math.ceil((winStamp - createStamp) / (86400000)); // 1000*60*60*24

		//if (!days) { //debug
		//	console.log(`Math.ceil((${winStamp} - ${createStamp}) / (86400000)) === ${days}`);
		//}

		return formatNumber(days);
	}

	toString() {
		let d = this._internalDate;
		let month = formatNumber(d.getUTCMonth() + 1);
		let day = formatNumber(d.getUTCDay());

		return `${d.getUTCFullYear()}-${month}-${day}`;
	}
}



/** WEBPACK FOOTER **
 ** ./frontend/utils/date.js
 **/